// extracted by mini-css-extract-plugin
export default {"MainCont":"MakeUp_MainCont__zH3nR","LeftCont":"MakeUp_LeftCont__0EIbw","RightCont":"MakeUp_RightCont__FjHIQ"};